module.exports = __webpack_public_path__ + "static/Sara-bf625f9a036185601c86b91280b5c6b0.png";